<template>
  <div class="article-box-mobile">
    <div
      class="left-img"
      :style="{
        backgroundImage:
          'url(' + 'https://help.yingzhongshare.com/' + article.showImage + ')',
      }"
      v-if="article.showImage"
    ></div>
    <div v-else class="img-cover"></div>

    <div class="right-info">
      <div class="title">{{ article.title }}</div>
      <div class="time">
        {{ article.created.split(" ")[0].split("-").join(".") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleBox",
  props: {
    articleData: Object,
  },
  data() {
    return {
      article: {},
    };
  },
  created() {
    this.article = this.articleData;
  },
};
</script>

<style lang="less" scoped>
.article-box-mobile {
  width: 100%;
  height: 88px;
  display: flex;
  justify-content: space-between;
  font-size: 14px;

  .left-img {
    width: 132px;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    border-radius: 10px;
  }
  .img-cover {
    width: 132px;
    height: 100%;
    border-radius: 10px;
    background-image: url("../../../assets/img/pc/dynamic/article/img_cover.png");
    background-color: #f8f8f8;
    background-repeat: no-repeat;
    background-size: 20%;
    background-position: center center;
  }

  .right-info {
    flex: 1;
    margin-left: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;

    .title {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      line-height: 24px;
      color: #222222;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
    }

    .time {
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
    }
  }
}
</style>